import Logo from "../../components/Logo";
import User from "./User";
import NavItem from "./NavItem";

import LogoutIcon from '@mui/icons-material/Logout';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import NotesIcon from '@mui/icons-material/Notes';
import { useMsal } from "@azure/msal-react";
import AdminButton from "../../components/AdminButton";
import { useEffect, useState } from "react";
import { useDataContext } from "../../data/DataContext";


function Nav(): React.ReactElement {

    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    };

    useEffect(() => {
        const account = instance.getAllAccounts()[0];
        if (account.name) {
            setName(account.name)
        }
        if (account.username) {
            setEmail(account.username)
        }
    }, [instance])

    const { isAdmin } = useDataContext();

    return (
        <nav>
            <div className="nav-top">
                <Logo/>
            </div>
            <div className="nav-bottom">
                <User name={name} email={email}/>
                {isAdmin? <AdminButton/> : null}
                <NavItem label="Hilfe" Icon={QuestionMarkIcon}/>
                <NavItem label="Logout" Icon={LogoutIcon} onClick={() => handleLogout()}/>
                <NavItem label="Impressum" Icon={NotesIcon}/>
            </div>
        </nav>
    );
}

export default Nav;